import React from "react";

const PageHeading = ({ headingClass, headingText }) => {
  return (
    <h1 id="main-heading" className={headingClass} tabIndex={-1}>
      {headingText}
    </h1>
  );
};

export default PageHeading;
